const config = {
  local: {
    apiPath: 'http://127.0.0.1:8081/'
  },
  dev: {
    apiPath: 'http://39.106.152.157:8081/'
  },
  test: {
    apiPath: 'http://47.94.245.248:8089/'
  },
  prod: {
    // apiPath: 'http://hui-admin.zpyhsc.com/zp-admin/'
    apiPath: '/zp-admin/'
  }
};
let type = '';
export default config[type || process.env.TYPE];



// WEBPACK FOOTER //
// ./src/config/index.js